//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "vux";
import { mapState } from "vuex";

import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import SrmCommonUtils from "@/utils/SrmCommonUtils"

export default {
  data() {
    return {
      searchValue: "",
      items: [],

      /** 刷新用变量 */
      pageIndex: 1,
      pageRows: 10,
      refreshing: true,
      finished: false,
      loading: false,
    };
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
      dicCodes: (state) => state.user.dicCodes,
    }),
  },
  created() {},
  activated: function () {},
  methods: {
    //搜索 输入
    onInput() {
      this.items.splice(0, this.items.length); //清空数据
      this.onRefresh(); //重新请求
    },
    onRefresh() {
      //状态设置
      this.refreshing = true;
      this.loading = true;
      this.finished = false;
      //页数设置
      this.pageIndex = 1;
      this.onLoad();
    },
    onLoad() {
      this.requestItems();
    },
    requestItems() {
      fetch
        .orderListByDetailPage({
          lan: this.languageCode,
          pageIndex: this.pageIndex, //页数
          pageRows: this.pageRows,
          poNum: this.searchValue,
        })
        .then((res) => {
          console.log(res);
          //状态设置
          this.refreshing = false;
          this.loading = false;
          if (res.status === "S") {
            if (res.status === "S") {
              //清楚最后多余的数据
              const curPageIndex = res.page.curIndex; //页数
              const curIndex = (curPageIndex - 1) * this.pageRows; //index
              const lastLength = this.items.length - curIndex; //剩余长度
              this.items.splice(curIndex, lastLength);

              this.items = this.items.concat(res.data); //拼接数据
              if (res.data.length >= this.pageRows) {
                this.pageIndex = res.page.nextIndex; //更新页数
              } else {
                //数据length不足row，没有更多数据，不继续往后加载
                this.finished = true;
              }
            }
          }
        });
    },
    onClickItem(item) {
      this.$router.push({
        path: "/Order",
        query: {
          poHeaderId: item.poHeaderId,
        },
      });
    },
    /**快码获取*/
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)

    },
    /**格式化数字*/
    getFormatNumberValue(val) {
      return new SrmCommonUtils(this).getFormatNumberValue(val)
    }
  },
  watch: {},
  mounted() {
    this.requestItems();
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/order/orderComfirm.vue